<template>
  <div v-if="editMode || dgRowInEditMode[gridId + '.' + rowKey]">
    <b-form-input
      v-if="options.isReactive"
      v-model.trim="$v.value.$model"
      :class="{ 'is-invalid': $v.value.$error }"
      @keydown.enter="save"
      @keydown.ctrl.83.prevent="save"
      @blur="save"
      type="number"
      :disabled="controlInfo.readonly"
    />
    <b-form-input
      v-else
      v-model.trim="$v.value.$model"
      :class="{ 'is-invalid': $v.value.$error }"
      @change="save"
      type="number"
      :disabled="controlInfo.readonly"
    />
    <b-form-invalid-feedback v-if="!$v.value.required">{{ controlInfo.label }} is required</b-form-invalid-feedback>
  </div>
  <div v-else>
    <span
      style="text-align: right;display: block;"
      v-if="options.meta[cellKey].priceFormat && value"
    >{{ dashboardSettings.regional.currency }}{{ value | numeralFormat('0,0') }}</span>
    <span v-else>{{ value }}</span>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { requiredIf } from 'vuelidate/lib/validators'
// services
import db from '@/services/db'
// helpers
import eventBus from '@/helpers/event-bus'

export default {
  props: [
    'rowKey',
    'cellKey',
    'cellVal',
    'options',
    'gridId',
    'widgetKey',
    'display',
    'editMode',
    'fbField',
    'controlInfo',
  ],
  data() {
    return {
      rowInst: null,
      value: this.cellVal,
    }
  },
  watch: {
    cellVal() {
      this.value = this.cellVal
    },
  },
  computed: {
    ...mapState(['dgRowInEditMode', 'currentDash', 'dashboardSettings']),
    isRequired() {
      return this.controlInfo.required
    },
  },
  methods: {
    save() {
      if (this.controlInfo.readonly) return
      if (this.$v.value.$error) return

      let value = null

      try {
        value = parseFloat(this.value)
        if (isNaN(value)) value = null
      } catch (err) {}

      const data = {
        options: this.options,
        rowKey: this.rowKey,
        cellKey: this.cellKey,
        value,
      }

      if (
        this.options.isReactive ||
        typeof this.options.isReactive === 'undefined'
      ) {
        if (this.cellVal === this.value) return

        db.dataGrid.data.saveCellVal(data)
      } else {
        this.rowInst.rowData[this.cellKey] = value
      }
    },
    editField() {
      if (this.fbField) {
        $dgShowEditRowModal(this.gridId, this.rowKey)
      } else {
        const currentQuery = JSON.stringify(this.$route.query)
        const editQuery = {
          dgEditMode: true,
          gridId: this.gridId,
          rowKey: this.rowKey,
        }
        const query = Object.assign(JSON.parse(currentQuery), editQuery)

        this.$router.push({ path: '/dashboard/' + this.currentDash, query })
      }
    },
  },
  created() {
    this.$nextTick(() => {
      this.rowInst = this.$instByClass(this, 'data-grid__row')
    })
  },
  beforeDestroy() {
    this.value = null
  },
  validations: {
    value: {
      required: requiredIf('isRequired'),
    },
  },
}
</script>
